import { useEffect } from "react";
import { useState } from "react"
import { toast } from "react-toastify";
import { get, post } from "../../controllers/apiController";
import Layout from "../../components/Layout";
import { Select2WColor, Select2 } from "../../components/Select2";
import DataTable from "react-data-table-component";

import * as XLSX from 'xlsx';
import { normalizeLeadInfo } from '../../utils/leadUtils';

const Reports = () => {
    const [labels, setLabels] = useState([]);
    const sources = [
        { value: "Meta", label: "Meta" },
        { value: "Manuel", label: "Manuel" },
        { value: "Ads", label: "Ads" },
        { value: "Landing Page", label: "Landing Page" },
        { value: "WordPress", label: "WordPress" }
    ];
    const [selectedLabels, setSelectedLabels] = useState(null);
    const [selectedSources, setSelectedSources] = useState(null);

    const [loading, setLoading] = useState(true);

    const [leads, setLeads] = useState([]);

    const [showLeadsModal, setShowLeadsModal] = useState(false);

    const [startDate, setStartDate] = useState(null);
    const [lastDate, setLastDate] = useState(null);

    useEffect(() => {
        document.title = "Rapor Oluştur | LEVELUP CRM";

        const getLabels = async () => {
            try {
                const response = await get("labels/");

                const labelsMapped = response.map(etiket => {
                    return {
                        value: etiket.Etiket_ID,
                        label: etiket.Etiket_Adi,
                        color: "#" + etiket.Etiket_Renk
                    }
                });

                setLabels(labelsMapped);

                setLoading(false);
            } catch (err) {
                toast.error("Etiketler alınırken bir hata oluştu!");
            }
        }

        getLabels();
    }, []);

    const createReport = async () => {
        try {
            if (selectedLabels == null || selectedLabels.length === 0) {
                const response = await post("reports/", {
                    startDate: startDate,
                    lastDate: lastDate,
                    sources: selectedSources != null ? selectedSources.map(source => source.value) : []
                });

                setLeads(response.map(normalizeLeadInfo));
            } else {
                const response = await post("reports/", {
                    labelIds: selectedLabels.map(label => {
                        return label.value
                    }),
                    startDate: startDate,
                    lastDate: lastDate,
                    sources: selectedSources != null ? selectedSources.map(source => source.value) : []
                });

                setLeads(response.map(normalizeLeadInfo));
            }

            setShowLeadsModal(true);
        } catch (err) {
            toast.error("Rapor oluşturulurken bir hata oluştu.");
        }
    }

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
        rows: {
            style: {
                padding: '20px 0',
            },
        },
        modalBackdropStyle: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1040
        }
    };

    const columns = [
        {
            name: 'ADI SOYADI',
            cell: row => (
                <div>
                    <span className="text-truncate-1-line">{row.LeadInfo.Adi_Soyadi}</span>
                </div>
            ),
            sortable: true
        },
        {
            name: 'TELEFON',
            cell: row => (
                <a href={`tel:${row.LeadInfo.Telefon}`}>{row.LeadInfo.Telefon}</a>
            ),
            sortable: true
        },
        {
            name: 'KAYNAK',
            cell: row => {
                const normalizedSource = row?.LeadInfo?.Kaynak ? row.LeadInfo.Kaynak.toLowerCase() : '';
                return (
                    <div className="hstack gap-2">
                        <div className="avatar-text avatar-sm">
                            <i className={`feather-${(normalizedSource === 'meta' ? 'facebook' : (normalizedSource === 'ads' ? 'google' : 'globe'))}`}></i>
                        </div>
                        <a href="javascript:void(0);">{row.LeadInfo.Kaynak}</a>
                    </div>
                )
            },
            sortable: true
        },
        {
            name: 'TARIH',
            cell: row => {
                const tarih = new Date(row.LeadInfo.Tarih);
                const formatliTarih = `${tarih.getDate().toString().padStart(2, '0')}.${(tarih.getMonth() + 1).toString().padStart(2, '0')}.${tarih.getFullYear()} ${tarih.getHours().toString().padStart(2, '0')}:${tarih.getMinutes().toString().padStart(2, '0')}`;
                return <span className="fw-semibold">{formatliTarih}</span>
            },
            sortable: true
        },
        {
            name: 'ETİKET',
            cell: row => {
                return (
                    <div className="d-flex gap-2">
                        <div className="badge" style={{ backgroundColor: `#${row.Etiketler[0].Etiket_Renk}`, color: `#${row.Etiketler[0].Etiket_Yazi_Renk}` }}>
                            {row.Etiketler[0].Etiket_Adi}
                        </div>
                        {row.Etiketler.length > 1 && (
                            <div className="badge" style={{ backgroundColor: "#efefef", color: "#7f7f7f" }}>
                                +{row.Etiketler.length - 1}
                            </div>
                        )}
                    </div>
                )
            },
            sortable: true
        },
        {
            name: 'TEMSİLCİ',
            cell: row => {
                return (
                    <span>{row.Temsilci_Isim != "null null" ? row.Temsilci_Isim : "Yok"}</span>
                );
            },
            sortable: true
        }
    ];

    const excelDownload = async () => {
        const data = leads;

        // Excel için verileri sütun başlıklarına göre yeniden düzenleme
        const excelData = data.map(row => {
            return {
                'ADI SOYADI': row.LeadInfo.Adi_Soyadi,
                'E-POSTA ADRESİ': row.LeadInfo.E_Posta,
                'TELEFON': row.LeadInfo.Telefon,
                'KAYNAK': row.LeadInfo.Kaynak,
                'META KAMPANYA': row.LeadInfo.Kampanya,
                'UTM SOURCE': row.LeadInfo.UTM_Source,
                'UTM MEDIUM': row.LeadInfo.UTM_Medium,
                'UTM REKLAM GRUBU': row.LeadInfo.UTM_Reklam_Grubu,
                'UTM KAMPANYA': row.LeadInfo.UTM_Campaign,
                'UTM KELİME': row.LeadInfo.UTM_Kelime,
                'REFERRER URL': row.LeadInfo.Referrer_URL,
                'TARIH': row.LeadInfo.Tarih,
                'ETİKET': row.Etiketler.map(label => label.Etiket_Adi).join(', '),
                'TEMSİLCİ': row.Temsilci_Isim != "null null" ? row.Temsilci_Isim : "Yok",
                'IP': row.LeadInfo.IP,
                'COOKIE': row.Cookie,
                'MESAJ': row.LeadInfo.Mesaj,
                'AÇIKLAMA': row.LeadInfo.Aciklama,
                'NOTLAR': JSON.stringify(row.Notlar)
            };
        });

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Formlar");

        // Sütun genişliklerini ayarlama
        const wscols = [
            { wch: 30 }, // KAMPANYA ADI
            { wch: 15 }, // GÖSTERİMLER
            { wch: 15 }, // ERİŞİMLER
            { wch: 15 }, // TIKLAMALAR
            { wch: 10 }, // TBM
            { wch: 15 }, // FORM SAYISI
            { wch: 20 }, // SONUÇ BAŞINA ÜCRET
            { wch: 15 }  // HARCAMA
        ];
        ws['!cols'] = wscols;

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Formlar_${new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(/\//g, '.').replace(':', '.')}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    return (
        <Layout>
            <main className="nxl-container">
                {loading ? (
                    <div>Yükleniyor...</div>
                ) : (
                    <div className="nxl-content">
                        <div className="page-header">
                            <div className="page-header-left d-flex align-items-center">
                                <div className="page-header-title">
                                    <h5 className="m-b-10">LEVELUP CRM</h5>
                                </div>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                    <li className="breadcrumb-item">Rapor Oluştur</li>
                                </ul>
                            </div>
                        </div>
                        <div className="main-content">
                            <div className="row">
                                <div className="col-xxl-12 col-md-12">
                                    <div className="card stretch stretch-full">
                                        <div className="card-header">
                                            <h5 className="card-title">Rapor Oluştur</h5>
                                        </div>
                                        <div className="card-body custom-card-action p-4">
                                            <div className="row mb-4 align-items-center">
                                                <label className="fw-semibold mb-2">Etiket (<b>Zorunlu değil</b>): </label>
                                                <Select2WColor
                                                    value={selectedLabels}
                                                    key={"labelSelect"}
                                                    options={labels}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}
                                                    onChange={(e) => setSelectedLabels(e)}
                                                    style={{ padding: 0 }}
                                                />
                                            </div>
                                            <div className="row mb-4 align-items-center">
                                                <label className="fw-semibold mb-2">Kaynak (<b>Zorunlu değil</b>): </label>
                                                <Select2
                                                    value={selectedSources}
                                                    key={"sourceSelect"}
                                                    options={sources}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}
                                                    onChange={(e) => setSelectedSources(e)}
                                                    style={{ padding: 0 }}
                                                />
                                            </div>
                                            <div className="row mb-4 align-items-center">
                                                <label className="fw-semibold mb-2">Başlangıç Tarihi: </label>
                                                <div className="p-2">
                                                    <input type="datetime-local" className="form-control" id="startDate" onChange={(e) => setStartDate(e.target.value)} value={startDate} />
                                                </div>
                                            </div>
                                            <div className="row mb-4 align-items-center">
                                                <label className="fw-semibold mb-2">Bitiş Tarihi: </label>
                                                <div className="p-2">
                                                    <input type="datetime-local" className="form-control" id="lastDate" onChange={(e) => setLastDate(e.target.value)} value={lastDate} />
                                                </div>
                                            </div>
                                            <button onClick={createReport} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Rapor Oluştur</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showLeadsModal && (
                            <div className="modal fade show" style={{ display: 'block' }}>
                                <div className="modal-dialog" style={{ maxWidth: '90%' }}>
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Formlar</h5>
                                            <button type="button" className="btn-close" onClick={() => setShowLeadsModal(false)}></button>
                                        </div>
                                        <div className="modal-body" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                                            <div className="row">
                                                <div className="col-xxl-3 col-md-6">
                                                    <div className="card stretch stretch-full">
                                                        <div className="card-body">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="avatar-text avatar-xl rounded">
                                                                        <i className="feather-users"></i>
                                                                    </div>
                                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                                        <span className="d-block">Manuel Form Sayısı</span>
                                                                        <span className="fs-24 fw-bolder d-block">{leads.filter(lead => lead.LeadInfo.Kaynak === "Manuel").length}</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xxl-3 col-md-6">
                                                    <div className="card stretch stretch-full">
                                                        <div className="card-body">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="avatar-text avatar-xl rounded">
                                                                        <i className="feather-facebook"></i>
                                                                    </div>
                                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                                        <span className="d-block">Meta Form Sayısı</span>
                                                                        <span className="fs-24 fw-bolder d-block">{leads.filter(lead => lead.LeadInfo.Kaynak === "Meta").length}</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xxl-3 col-md-6">
                                                    <div className="card stretch stretch-full">
                                                        <div className="card-body">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="avatar-text avatar-xl rounded">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M11.99 13.9v-3.72h9.36c.14.63.25 1.22.25 2.05c0 5.71-3.83 9.77-9.6 9.77c-5.52 0-10-4.48-10-10S6.48 2 12 2c2.7 0 4.96.99 6.69 2.61l-2.84 2.76c-.72-.68-1.98-1.48-3.85-1.48c-3.31 0-6.01 2.75-6.01 6.12s2.7 6.12 6.01 6.12c3.83 0 5.24-2.65 5.5-4.22h-5.51z" /></svg>
                                                                    </div>
                                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                                        <span className="d-block">Landing Page Form Sayısı</span>
                                                                        <span className="fs-24 fw-bolder d-block">{leads.filter(lead => lead.LeadInfo.Kaynak === "Landing Page").length}</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xxl-3 col-md-6">
                                                    <div className="card stretch stretch-full">
                                                        <div className="card-body">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="avatar-text avatar-xl rounded">
                                                                        <i className="feather-globe"></i>
                                                                    </div>
                                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                                        <span className="d-block">WordPress Form Sayısı</span>
                                                                        <span className="fs-24 fw-bolder d-block">{leads.filter(lead => lead.LeadInfo.Kaynak === "WordPress").length}</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <DataTable
                                                columns={columns}
                                                data={leads}
                                                className="table table-hover mb-0"
                                                pagination
                                                responsive
                                                noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                paginationComponentOptions={paginationComponentOptions}
                                                customStyles={customStyles}
                                                paginationPerPage={10}
                                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            />
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" onClick={() => setShowLeadsModal(false)}>Kapat</button>
                                            {leads.length > 0 && <button type="button" onClick={excelDownload} className="btn btn-primary">Excel İndir</button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {showLeadsModal && (
                            <div style={customStyles.modalBackdropStyle} onClick={() => setShowLeadsModal(false)} />
                        )}
                    </div>
                )}
            </main>
        </Layout >
    );
}

export default Reports;